<template>
  <div :class="{ 'hestia-careers-route': enabled }">
    <WebsiteBuilderHestiaIframeView
      v-if="enabled"
      fixed-target-path
      brand-scoped-target
      :target-path="targetPath"
      :location-id="locationId"
    />
    <CareersView v-else-if="locationId" :selected-view="selectedView" />
    <PageBlocker v-else />
  </div>
</template>

<script lang="ts" setup>
import { isChromeLessIframeSession } from '@/auth/iframeSession'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import PageBlocker from '@/core/public/PageBlocker.vue'
import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'
import WebsiteBuilderHestiaIframeView from '@/features/website-builder/views/WebsiteBuilderHestiaIframeView.vue'
import CareersView from './CareersView.vue'

const route = useRoute()
const { enabled: rolloutEnabled } = useReactiveFeatureFlag(
  'hermes.hestiaWebsiteCareers'
)
// A legacy tool embedded by Hestia must not embed Hestia back into itself.
const enabled = computed(
  () => rolloutEnabled.value && !isChromeLessIframeSession()
)
const locationId = computed(() =>
  typeof route.params.locationId === 'string'
    ? route.params.locationId
    : undefined
)
const selectedView = computed(() =>
  String(route.name).includes('.jobs') ? 'jobs' : 'applications'
)
const targetPath = computed(() => {
  const { jobId, applicationId } = route.params
  const base = '/website/manage/careers'
  if (typeof applicationId === 'string')
    return `${base}/applications/${encodeURIComponent(applicationId)}`
  if (typeof jobId === 'string')
    return `${base}/jobs/${encodeURIComponent(jobId)}`
  if (route.name === 'location.careers.jobs.new') return `${base}/jobs/new`
  return `${base}?view=${selectedView.value}`
})
</script>

<style scoped>
.hestia-careers-route {
  height: 100%;
}
</style>
